import React, { useState, useEffect } from 'react';
import styles from '../components/pmn/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import MenuScreen from '../common/menu-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import CharacteristicScreen from '../components/lm-d-s/characteristic-screen';
import InfoScreen from '../components/lm-d-s/info-screen';
import AuthorityScreen from '../common/authority-screen';
import WelcomeChallengeScreen from '../common/challenge-component/welcome-challenge-screen';
import DailyTasksChallenge from '../common/challenge-component/daily-tasks-challenge';
import ResultInfoScreen from '../common/challenge-component/result-info-screen';
import FinalScreen from '../components/lm-d-s/final-screen';
import { useContext } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import ProhibitedChapterScreen from '../components/lm-d-s/prohibited-chapter-screen';
import AllBrandsScreen from '../common/all-brands-screen';
import BrandLineScreen from '../common/brand-line-screen';
import PredictionScreen from '../common/prediction-screen';
import WelcomeScreen from '../components/mpmnm/welcome-screen';
import { getImageFromS3 } from '../imageService';
import ReviewFlowScreen from '../common/review-flow-screen';
import { CURRENT_CHALLENGE_NAME } from '../consts/challengeName';
import useScreenHistory from '../hooks/useScreenHistory';

const dailyTasksChallengeList = {
  1: <>Спробуй новий вид спорту 🏓</>,
  2: <>Прочитай книгу з жанру, якого ти ніколи не читав(-ла) 📕</>,
  3: <>Напиши листа друзям чи родині та відправ його поштою ✉</>,
  4: <>Спробуй створити своїми руками подарунок для когось 🎁</>,
  5: <>Відвідай новий ресторан або кав'ярню 🍔</>,
  6: <>Проведи день без технологій 💡</>,
  7: <>Вивчи слова пісні на іншій мові та спробуй виконати її 🎵</>,
  8: <>Спробуй медитацію або йогу 🧘‍♂️</>,
  9: <>Подивися фільм у жанрі, якого ти раніше не переглядав(-ла) 🎬</>,
  10: (
    <>
      Влаштуй день самопілота: роби те, що приходить в голову, без планування 🧐
    </>
  ),
  11: <>Запиши свої мрії і цілі на папері 📜</>,
  12: <>Спробуй новий вид танцю 💃</>,
  13: <>Займись благодійністю: пожертвуй речі чи час 💸</>,
  14: <>Створи список вдячності за те, що ти маєш 📜</>,
  15: <>Вивчи рецепт та приготуй десерт 🧁</>,
  16: <>Створи свій плейлист для різних настроїв 🎼</>,
  17: <>Стань волонтером на один день ✨</>,
  18: <>Організуй пікнік у парку чи на природі 🥪</>,
  19: <>Вивчи базові фрази на іншій мові 😎</>,
  20: (
    <>Створи своє власне правило життя та дотримуйся його протягом тижня 😎</>
  ),
  21: <>Напиши вірш про своє життя 📜</>
};

const menuList = [
  {
    id: 'challenge',
    screenNumber: 6,
    name: CURRENT_CHALLENGE_NAME,
    icon: 'images/common/menu-icon/may-challenge-menu-icon.svg'
  },
  {
    id: 'foresight',
    screenNumber: 16,
    name: 'Передбачення на сьогодні',
    icon: 'images/lm-double-splash/foresight-menu-icon.svg'
  },
  {
    id: 'characteristic',
    screenNumber: 2,
    name: 'Характеристики сигарет',
    icon: 'images/common/menu-icon/characteristic-menu-icon.svg'
  },
  {
    id: 'about',
    screenNumber: 3,
    name: 'Все про Філіп Морріс Україна',
    icon: 'images/common/menu-icon/info-menu-icon.svg'
  },
  {
    id: 'authority',
    screenNumber: 14,
    name: 'Сигарети з капсулами забороняють?',
    icon: 'images/lm-double-splash/authority-menu-icon.svg'
  },
  {
    id: 'review_main',
    screenNumber: 5,
    name: 'Залишити відгук про продукт',
    icon: 'images/common/menu-icon/review-menu-icon.svg'
  }
];

const partners = {
  cig: 'https://cig-poshta.in.ua/shop/philip-morris/?utm_source=SP',
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=philip-morris/'
};

const lmLoftPurple = {
  title: 'L&M Loft Purple',
  pack: getImageFromS3('images/packs/lm/loft-purple.png'),
  tobaccoFirst: 'Вміст смол, мг - 5',
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('images/parliament/filter.png'),
  background: `url("${getImageFromS3('images/lm-l-green/background.png')}")`,
  isDarkButton: true,
  isNewMixture: true,
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: <span>Ацетатна частина</span>,
      bordered: true
    },
    {
      description: <span>Вугільна частина</span>,
      bordered: true
    },
    {
      description: (
        <span>
          Ущільнена повітряна камера з ацетатною стінкою, що робить смак м'яким
          і більш збалансованим
        </span>
      ),
      bordered: true
    }
  ]
};

const novelPurple = {
  title: 'Philip Morris Novel Purple',
  pack: getImageFromS3('images/packs/philip-morris/novel-purple.png'),
  background: `url("${getImageFromS3('images/lm-l-green/background.png')}")`,
  tobaccoFirst: 'Вміст смол, мг - 5',
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('images/parliament/filter.png'),
  isDarkButton: true,
  isNewMixture: true,
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: <span>Ацетатна частина</span>,
      bordered: true
    },
    {
      description: <span>Вугільна частина</span>,
      bordered: true
    },
    {
      description: (
        <span>
          Ущільнена повітряна камера з ацетатною стінкою, що робить смак м'яким
          і більш збалансованим
        </span>
      ),
      bordered: true
    }
  ]
};

const lmLoftGreen = {
  title: 'L&M Loft Green',
  pack: getImageFromS3('images/packs/lm/loft-green.png'),
  tobaccoFirst: 'Вміст смол, мг - 5',
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('images/parliament/filter.png'),
  background: `url("${getImageFromS3('images/lm-l-green/background.png')}")`,
  isDarkButton: true,
  isNewMixture: true,
  newMixtureText: 'Особлива тютюнова суміш',
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: <span>Ацетатна частина</span>,
      bordered: true
    },
    {
      description: <span>Вугільна частина</span>,
      bordered: true
    },
    {
      description: (
        <span>
          Ущільнена повітряна камера з ацетатною стінкою, що робить смак м'яким
          і більш збалансованим
        </span>
      ),
      bordered: true
    }
  ]
};

const chesterfieldRetuned = {
  title: 'Chesterfield Retuned',
  pack: getImageFromS3('images/packs/chesterfield/retuned.png'),
  background: `url("${getImageFromS3('images/lm-l-green/background.png')}")`,
  tobaccoFirst: 'Вміст смол, мг - 5',
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('images/parliament/filter.png'),
  isDarkButton: true,
  isNewMixture: true,
  newMixtureText: 'Особлива тютюнова суміш',
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: <span>Ацетатна частина</span>,
      bordered: true
    },
    {
      description: <span>Вугільна частина</span>,
      bordered: true
    },
    {
      description: (
        <span>
          Ущільнена повітряна камера з ацетатною стінкою, що робить смак м'яким
          і більш збалансованим
        </span>
      ),
      bordered: true
    }
  ]
};

const philipMorrisNovelMix = {
  title: 'Philip Morris Novel Mix',
  pack: getImageFromS3('images/packs/philip-morris/novel-mix.png'),
  tobaccoFirst: 'Вміст смол, мг - 6',
  background: `url("${getImageFromS3('images/pmn/background.png')}")`,
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('images/pmn/pmnm/filter.png'),
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: (
        <span>
          <b>Класичний ацетатний фільтр</b>
          <br /> з високоякісної целюлози, який затримує тверді частинки
          сигаретного диму. Містить капсулу зі смаком літніх соковитих фруктів.
        </span>
      ),
      bordered: false
    }
  ]
};

const philipMorrisNovelMixSummer = {
  title: 'Philip Morris Novel Mix Summer',
  pack: getImageFromS3('images/packs/philip-morris/novel-mix-summer.png'),
  tobaccoFirst: 'Вміст смол, мг - 6',
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('/images/pmn/pmnms/filter.png'),
  background: `url("${getImageFromS3('images/pmn/background.png')}")`,
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: (
        <span>
          <b>Класичний ацетатний фільтр</b>
          <br /> з високоякісної целюлози, який затримує тверді частинки
          сигаретного диму. Містить капсулу зі смаком літніх соковитих фруктів.
        </span>
      ),
      bordered: false
    }
  ]
};

const bondPremiumMix = {
  title: 'Bond Street Premium Mix',
  pack: getImageFromS3('images/packs/bond/premium-mix.png'),
  tobaccoFirst: 'Вміст смол, мг - 5',
  tobaccoSecond: 'Вміст нікотину, мг - 0.4',
  filterIcon: getImageFromS3('images/bond/filter.png'),
  background: `url("${getImageFromS3('images/bond/background.png')}")`,
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: (
        <span>
          <b>Класичний ацетатний фільтр</b> з високоякісної целюлози, який
          затримує тверді частинки сигаретного диму. Містить капсулу зі смаком
          лісових ягід.
        </span>
      ),
      bordered: false
    }
  ]
};

export default function PMNM() {
  const toReviewButton = sessionStorage.getItem('r_b') === 'true';
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: toReviewButton ? 5 : 0,
      initialState: { brandLine: '' }
    });
  const brandLine = historyState.brandLine || '';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init('Novel Mix');
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case -1: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => {
              setScreenNumber(15, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(4, true)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 0: {
        return (
          <WelcomeScreen
            setScreenNumber={cb}
            handleBackButton={() => setScreenNumber(1, true)}
            backgroundImage={`url("${getImageFromS3(
              'images/lm-double-splash/violet-background.png'
            )}")`}
          />
        );
      }
      case 1: {
        return (
          <MenuScreen
            setScreenNumber={cb}
            menuList={menuList}
            backgroundImage={`url("${getImageFromS3(
              'images/pmn/background.png'
            )}")`}
          />
        );
      }
      case 2: {
        return (
          <CharacteristicScreen
            brandId="philip-morris"
            isNewMixture={philipMorrisNovelMix?.isNewMixture}
            title={philipMorrisNovelMix?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={
              philipMorrisNovelMix?.filterCharacteristicList
            }
            infoList={philipMorrisNovelMix?.characteristicInfoList}
            tobaccoFirst={philipMorrisNovelMix?.tobaccoFirst}
            tobaccoSecond={philipMorrisNovelMix?.tobaccoSecond}
            packImage={philipMorrisNovelMix?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={philipMorrisNovelMix?.background}
            filterIcon={philipMorrisNovelMix?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 3: {
        return (
          <InfoScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(9)}
          />
        );
      }
      case 4: {
        return (
          <AuthorityScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(9)}
            partners={partners}
          />
        );
      }
      case 5: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            setSubmitReviewScreenNumber={() => setScreenNumber(10)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(5, false, { innerScreenNumber: val })
            }
          />
        );
      }
      case 6: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title={
              <>
                Готовий
                <br />
                до цікавого челенджу?
              </>
            }
            description={`Виконай наше завдання та зроби свій день яскравішим.`}
            buttonTitle="Почати"
            backgroundImage={`url("${getImageFromS3(
              'images/pmn/background.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(7)}
          />
        );
      }
      case 7: {
        return (
          <DailyTasksChallenge
            title={
              <>
                Твій челендж <br /> на сьогодні
              </>
            }
            acceptChallengeCopy="Приймаю виклик"
            setScreenNumber={setScreenNumber}
            backgroundImage={`url("${getImageFromS3(
              'images/pmn/background.png'
            )}")`}
            dailyTasksList={dailyTasksChallengeList}
            dailyTasksListCount={Object.keys(dailyTasksChallengeList).length}
          />
        );
      }
      case 8: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(9)}
            title="Як тобі завдання?"
            description={
              <>
                Виконай його й чудово проведи час! <br />
                <br /> Заходь до нас завтра та отримай новий челендж на день.
              </>
            }
            image={getImageFromS3('images/challenge/challenge-result.png')}
            backgroundImage={`url("${getImageFromS3(
              'images/pmn/background.png'
            )}")`}
          />
        );
      }
      case 9: {
        return (
          <FinalScreen
            setScreenNumber={cb}
            setScreenNumberToReview={() => setScreenNumber(5)}
            withReviewButton
            isUpdatedApp
          />
        );
      }
      case 10: {
        return <FinalScreen setScreenNumber={cb} />;
      }
      // case 11: {
      //   return (
      //     <WelcomeChallengeScreen
      //       setScreenNumber={cb}
      //       title={<>Який ти сезон?</>}
      //       description={`Хочеш дізнатися, якій порі року найбільше відповідає твій характер? Пройди коротенький тест і дивися результати.`}
      //       buttonTitle="Почати"
      //       backgroundImage={`url("/images/pmn/background.png")`}
      //       setNextScreenNumber={() => setScreenNumber(12)}
      //     />
      //   );
      // }
      // case 12: {
      //   return (
      //     <SelectSeasonChallenge
      //       backgroundImage={`url("/images/pmn/background.png")`}
      //       setScreenNumber={setScreenNumber}
      //       setNextScreenNumber={() => setScreenNumber(13)}
      //     />
      //   );
      // }
      case 13: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(9)}
            title="Погоджуєшся з результатом?"
            description={
              <>
                Кожна людина неповторна й важливо ділитися своєю унікальністю з
                іншими.
              </>
            }
            image={getImageFromS3('images/challenge/challenge-result-boy.png')}
            backgroundImage={`url("${getImageFromS3(
              'images/pmn/background.png'
            )}")`}
          />
        );
      }
      case 14: {
        return (
          <ProhibitedChapterScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(9)}
          />
        );
      }
      case 15: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(-1, true)}
            nextButtonClick={() => setScreenNumber(9)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 16: {
        return (
          <PredictionScreen
            setScreenNumber={setScreenNumber}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      case 17: {
        return (
          <CharacteristicScreen
            brandId="lm"
            isNewMixture={lmLoftGreen?.isNewMixture}
            title={lmLoftGreen?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={lmLoftGreen?.filterCharacteristicList}
            infoList={lmLoftGreen?.characteristicInfoList}
            tobaccoFirst={lmLoftGreen?.tobaccoFirst}
            tobaccoSecond={lmLoftGreen?.tobaccoSecond}
            packImage={lmLoftGreen?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={lmLoftGreen?.background}
            filterIcon={lmLoftGreen?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 18: {
        return (
          <CharacteristicScreen
            brandId="chesterfield"
            isNewMixture={chesterfieldRetuned?.isNewMixture}
            title={chesterfieldRetuned?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={
              chesterfieldRetuned?.filterCharacteristicList
            }
            infoList={chesterfieldRetuned?.characteristicInfoList}
            tobaccoFirst={chesterfieldRetuned?.tobaccoFirst}
            tobaccoSecond={chesterfieldRetuned?.tobaccoSecond}
            packImage={chesterfieldRetuned?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={chesterfieldRetuned?.background}
            filterIcon={chesterfieldRetuned?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 19: {
        return (
          <CharacteristicScreen
            brandId="philip-morris"
            isNewMixture={philipMorrisNovelMixSummer?.isNewMixture}
            title={philipMorrisNovelMixSummer?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={
              philipMorrisNovelMixSummer?.filterCharacteristicList
            }
            infoList={philipMorrisNovelMixSummer?.characteristicInfoList}
            tobaccoFirst={philipMorrisNovelMixSummer?.tobaccoFirst}
            tobaccoSecond={philipMorrisNovelMixSummer?.tobaccoSecond}
            packImage={philipMorrisNovelMixSummer?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={philipMorrisNovelMixSummer?.background}
            filterIcon={philipMorrisNovelMixSummer?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 20: {
        return (
          <CharacteristicScreen
            brandId="bond"
            isNewMixture={bondPremiumMix?.isNewMixture}
            title={bondPremiumMix?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={bondPremiumMix?.filterCharacteristicList}
            infoList={bondPremiumMix?.characteristicInfoList}
            tobaccoFirst={bondPremiumMix?.tobaccoFirst}
            tobaccoSecond={bondPremiumMix?.tobaccoSecond}
            packImage={bondPremiumMix?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={bondPremiumMix?.background}
            filterIcon={bondPremiumMix?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 21: {
        return (
          <CharacteristicScreen
            brandId="philip-morris"
            isNewMixture={novelPurple?.isNewMixture}
            title={novelPurple?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={novelPurple?.filterCharacteristicList}
            infoList={novelPurple?.characteristicInfoList}
            tobaccoFirst={novelPurple?.tobaccoFirst}
            tobaccoSecond={novelPurple?.tobaccoSecond}
            packImage={novelPurple?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={novelPurple?.background}
            filterIcon={novelPurple?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 22: {
        return (
          <CharacteristicScreen
            brandId="lm"
            isNewMixture={lmLoftPurple?.isNewMixture}
            title={lmLoftPurple?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={lmLoftPurple?.filterCharacteristicList}
            infoList={lmLoftPurple?.characteristicInfoList}
            tobaccoFirst={lmLoftPurple?.tobaccoFirst}
            tobaccoSecond={lmLoftPurple?.tobaccoSecond}
            packImage={lmLoftPurple?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={lmLoftPurple?.background}
            filterIcon={lmLoftPurple?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };
  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
}
